import React, { Fragment, useCallback, useState } from "react";
import Dropzone from "react-dropzone";
import ImageFromFile from "./ImageFromFile";
import Icon from "@fortawesome/react-fontawesome";
import _ from "lodash";

const ImagesInput = ({ form: { setFieldValue }, field: { value, name }, onDeleteProductImage }) => {
  const [newImages, setNewImages] = useState([])
  const [oldImages, setOldImages] = useState(value)
  console.log('top newImages: ', newImages)

  const onDrop = useCallback(
    files => {
      setFieldValue(name, [...value, ...files])
      setNewImages(files);
    },
    [name, setFieldValue, value]
  )

  const onClickDelete = useCallback(
    file => () => {
      console.log('on onClickDelete')
      const files = [...value]
      const index = _.indexOf(value, file)
      files.splice(index, 1)
      setFieldValue(name, files)
      console.log('file: ', file);
      console.log('newImages: ', newImages)
      if (file.id == null){
        console.log('on if');
        console.log('newImages: ', newImages)
        let showIndex = _.indexOf(newImages, file)
        console.log('showIndex: ', showIndex)
        setNewImages(newImages.splice(showIndex, 1))
        console.log('newImages: ', newImages)
      }  else {
        console.log('on else');
        onDeleteProductImage(file)
        console.log('after onDeleteProductImage: ', file);
        setOldImages(files)
      }
    },
    [value, setFieldValue, name, newImages, onDeleteProductImage]
  )
  console.log('outside newImages: ', newImages)
  console.log('value: ', value)
  return (
    <Fragment>
      <Dropzone multiple onDrop={onDrop} accept='image/*'>
        {({ getRootProps, getInputProps }) => (
          <div className='dropzone content text-center' {...getRootProps()}>
            <input {...getInputProps()} />
            <p className='text-info relative'>
              <Icon icon='camera' size='4x' />
            </p>
            <p>Drop files to upload.</p>
          </div>
        )}
      </Dropzone>
      {newImages  && (        
        <div className='row mt-3'>
          {newImages.map(image => (
            <div className='col-md-4 col-sm-6 mb-3'>
              <div className='closeable'>
                <div className='closeable-content'>
                  <ImageFromFile className='dropzone-image' image={image} />
                  <p className='text-info closeable-button'>
                    <Icon onClick={onClickDelete(image)} icon='times-circle' />
                  </p>
                </div>
              </div>
            </div>
            ))}
        </div>
      )}
      {oldImages && (
        <div className='row mt-3'>
          {oldImages.map(img => (
                      <div className='col-md-4 col-sm-6 mb-3' key={img.id + img.name}>
                        <div className='closeable'>
                          <div className='closeable-content'>
                            <img className={"image"} src={`${process.env.REACT_APP_API_URL}/${img.path}`} alt={img.name}/>
                            <p className='text-info closeable-button'>
                              <Icon onClick={onClickDelete(img)} icon='times-circle' />
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
         </div>   
      )}
    </Fragment>
  );
};

export default ImagesInput;
